/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import ReactPaginate from 'react-paginate';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import _, { isEmpty } from 'lodash';
import { FreeMode, Thumbs } from 'swiper/modules';
import {
  OurHistory,
  OurHistoryContainer,
  OurHistoryCaption,
  OurHistoryContent,
  OurHistoryPagination,
  OurHistoryPaginatinButton,
  HistoryNavigationButton,
  PrevButton,
  NextButton,
} from './styles/OurHistory.styled';
import Sprites from './Sprites';

export default function OurStory({ data, id, dir }) {
  const { title, description, timeline } = data;
  const [currentYear, setCurrentYear] = React.useState({
    year: '',
  });
  const [imageSwiper, setImageSwiper] = React.useState(null);
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);
  const handleClickNext = () => imageSwiper?.slideNext();
  const handleClickPrev = () => imageSwiper?.slidePrev();

  React.useEffect(() => {
    setCurrentYear(timeline[0]);
  }, []);

  const handleClick = (item, index) => {
    setCurrentYear(item);
    imageSwiper.slideTo(index);
    thumbsSwiper.slideTo(index);
  };

  const breakpoints = {
    0: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    640: {
      slidesPerView: 5,
      centeredSlides: false,
    },
    768: {
      slidesPerView: 5,
      centeredSlides: false,
    },
    1024: {
      slidesPerView: 5,
      centeredSlides: false,
    },
    1280: {
      slidesPerView: 10,
      centeredSlides: false,
    },
    1920: {
      slidesPerView: 14,
      centeredSlides: false,
    },
  };

  return (
    <OurHistory id={id} className="smoothed">
      <OurHistoryContainer>
        <OurHistoryCaption>
          <h2 dir={dir}>{title}</h2>
          {_.isEmpty(description)||
          <p dir={dir}>{description}</p>
          }
        </OurHistoryCaption>
        <OurHistoryContent dir={dir}>
          <Swiper
            slidesPerGroup={1}
            slidesPerView="auto"
            onSwiper={setImageSwiper}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[FreeMode, Thumbs]}
            onSlideChange={(swiper) => {
              const { activeIndex } = swiper;
              const currentItem = timeline[activeIndex];
              setCurrentYear(currentItem);
              thumbsSwiper.slideTo(activeIndex);
            }}
          >
            {timeline.map((value, index) => (
              <SwiperSlide key={index} dir={dir}>
                {isEmpty(value.content.image) || (
                  <LazyLoadImage
                    className="w-full h-full  object-cover"
                    src={value.content.image.url}
                    alt={value.title}
                    placeholderSrc={
                      value.content.image ? `${value.content.image.url}?width=50&quality=50` : null
                    }
                    effect="blur"
                  />
                )}

                <p>{value.content.description}</p>
              </SwiperSlide>
            ))}
          </Swiper>
          <HistoryNavigationButton>
            <PrevButton type="button" onClick={handleClickPrev}>
              <Sprites name="arrowprev" />
            </PrevButton>
            <NextButton type="button" onClick={handleClickNext}>
              <Sprites name="arrownext" />
            </NextButton>
          </HistoryNavigationButton>
        </OurHistoryContent>
        <OurHistoryPagination>
          <Swiper
            breakpoints={breakpoints}
            hashNavigation={{
              watchState: true,
            }}
            onSwiper={setThumbsSwiper}
            onSlideChange={(swiper) => {
              const { activeIndex } = swiper;
              const currentItem = timeline[activeIndex];
              setCurrentYear(currentItem);
              imageSwiper.slideTo(activeIndex);
            }}
          >
            {timeline.map((value, index) => (
              <SwiperSlide key={index} dir={dir}>
                <OurHistoryPaginatinButton onClick={() => handleClick(value, index)}>
                  <p>{value.content.year}</p>
                </OurHistoryPaginatinButton>
              </SwiperSlide>
            ))}
          </Swiper>
        </OurHistoryPagination>
      </OurHistoryContainer>
    </OurHistory>
  );
}
